import { dev } from "@phosphor/devstring";
import { createContext, useContext } from "react";
import { defineLiveStoreDemo } from "#shared/demos/defineLiveStoreDemo.tsx";
import { AutocompleteInput } from "#sources/autocomplete-demo/components/AutocompleteInput.tsx";
import { events, schema } from "#sources/autocomplete-demo/livestore/schema.ts";
import { createAutocompleteScope } from "#sources/autocomplete-demo/scope.ts";

const AutocompleteVMContext = createContext<any>(null);
const useAutocompleteVM = () => useContext(AutocompleteVMContext);

const AppBody = () => {
  const vm = useAutocompleteVM();
  return (
    <div data-loc="phosphor-blog/content/posts/view-model-interfaces/demos/autocomplete.ssr.tsx:14:10" className="demo-container max-w-2xl">
      <div data-loc="phosphor-blog/content/posts/view-model-interfaces/demos/autocomplete.ssr.tsx:15:12" className="mb-4">
        <h3 data-loc="phosphor-blog/content/posts/view-model-interfaces/demos/autocomplete.ssr.tsx:16:13" data-name="h3" className="text-sm font-medium mb-2 text-text">File Reference Autocomplete</h3>
        <p data-loc="phosphor-blog/content/posts/view-model-interfaces/demos/autocomplete.ssr.tsx:17:12" data-name="p" className="text-xs text-text-secondary mb-4">
          Type <code data-loc="phosphor-blog/content/posts/view-model-interfaces/demos/autocomplete.ssr.tsx:18:22" data-name="code" className="px-1 py-0.5 bg-bg border border-border rounded text-[10px]">@</code> followed by a filename to
          see autocomplete suggestions. Use arrow keys to navigate, Enter to select, or click an option.
        </p>
      </div>
      <AutocompleteInput vm={vm} />
    </div>
  );
};

export default defineLiveStoreDemo({
  source: dev`autocomplete-demo`.ctx({ loc: "phosphor-blog/content/posts/view-model-interfaces/demos/autocomplete.ssr.tsx:28:11" }),
  schema,
  boot: async (store) => {
    store.commit(
      events.uiStateSet({ inputText: "", selectedIndex: 0 }),
      events.fileAdded({ path: "src/index.html" }),
      events.fileAdded({ path: "src/index.ts" }),
      events.fileAdded({ path: "src/utils/index.ts" }),
      events.fileAdded({ path: "src/components/Button.tsx" }),
      events.fileAdded({ path: "src/components/Input.tsx" }),
      events.fileAdded({ path: "src/lib/helpers.ts" }),
      events.fileAdded({ path: "tests/index.test.ts" }),
      events.fileAdded({ path: "tests/integration.test.ts" }),
      events.fileAdded({ path: "README.md" }),
      events.fileAdded({ path: "package.json" }),
    );
  },
  RootComponent({ store }) {
    const vm = createAutocompleteScope(store);
    return (
      <AutocompleteVMContext.Provider value={vm}>
        <AppBody />
      </AutocompleteVMContext.Provider>
    );
  },
});
